import { render, staticRenderFns } from "./IconSectionHero.vue?vue&type=template&id=56b29029&"
import script from "./IconSectionHero.vue?vue&type=script&lang=js&"
export * from "./IconSectionHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b29029')) {
      api.createRecord('56b29029', component.options)
    } else {
      api.reload('56b29029', component.options)
    }
    module.hot.accept("./IconSectionHero.vue?vue&type=template&id=56b29029&", function () {
      api.rerender('56b29029', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSectionHero.vue"
export default component.exports